export const DISPLAY_SORT_DATE_ASCENDING = "dateasc";
export const DISPLAY_SORT_DATE_DESCENDING = "datedesc";
export const DISPLAY_SORT_DISCOUNT = "discount";
export const DISPLAY_SORT_PRICE_ASCENDING = "priceasc";
export const DISPLAY_SORT_PRICE_DESCENDING = "pricedesc";
export const DISPLAY_SORT_BRAND_ASCENDING = "brandasc";
export const DISPLAY_SORT_BRAND_DESCENDING = "branddesc";
export const DISPLAY_SORT_STOCK = "stock";
export const DISPLAY_SORT_RECENTLY_DISCOUNTED_STOCK = "recentlydiscounted";
